import { Link } from "react-router-dom";
import { PlusCircle, MagnifyingGlass } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export function NotFindingInstitution({ className = "" }) {
  return (
    <div
      className={`overflow-hidden rounded-3xl border border-orange-200 bg-orange-50 ${className}`}
      data-testid="not-finding-institution"
    >
      <div className="flex flex-col gap-6 p-8 sm:flex-row sm:items-center sm:justify-between sm:p-10">
        <div className="max-w-2xl">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-orange-100 px-3 py-1 text-xs font-medium text-orange-800">
            <MagnifyingGlass size={14} weight="bold" /> Global directory
          </div>
          <h2 className="font-heading text-2xl font-light tracking-tight text-orange-950 sm:text-3xl">Not finding your institution?</h2>
          <p className="mt-2 text-sm leading-relaxed text-orange-900/80">
            Can't find your school, college, university, or educational institution? Tell us about it.
            Give us whatever details you know — we'll research, verify, and work to add it to AlumniPulse™.
            We'll let you know when it's ready.
          </p>
          <p className="mt-2 text-xs text-orange-900/60">
            Small or large. New or historic. Local or global. Every institution has a story worth preserving.
          </p>
        </div>
        <div className="shrink-0">
          <Link to="/institutions/suggest">
            <Button
              size="lg"
              className="rounded-full gap-2 bg-orange-600 text-white shadow-sm transition-all hover:bg-orange-700 hover:shadow active:scale-95"
              data-testid="suggest-institution-cta"
            >
              <PlusCircle size={18} weight="fill" /> Suggest an Institution
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFindingInstitution;
